import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'
import { getOrMakeAnonymousUserId } from '@mote/helpers/identity'
import { useLocalStoragePermission } from '@mote/helpers/browser'
const STORAGE_PREFIX_KEYS = 'mote-auth-'

export const useTrackMutation = (route = null) => {
  const canAccessLocalStorage = useLocalStoragePermission()

  const { ...props } = useGenericRequestHandler({
    route: route ?? 's/track/everything',
    method: 'POST',
    responseType: 'text',
    options: {
      json: {
        page_context: window.location.href,
        direct: true,
        tracking_route: 'direct',
        tracking_source: 'website'
      }
    }
  })

  function getUserId() {
    return (
      window.localStorage?.getItem(STORAGE_PREFIX_KEYS + 'userId') ||
      getOrMakeAnonymousUserId().anonymousUserId
    )
  }

  function handleTrack(payload) {
    if (!canAccessLocalStorage) return

    payload.variables = { ...payload.variables, userId: getUserId() }
    return props.mutate(payload)
  }

  return { ...props, mutate: handleTrack }
}
